// extracted by mini-css-extract-plugin
module.exports = {"contentHeadline":"IhrCoach_contentHeadline__yb1S5","contentTable":"IhrCoach_contentTable__YIAV4","topic":"IhrCoach_topic__OO657"};